<template>
  <div class="home">
    <div id="webgl"></div>

    <!-- 弹窗 -->
    <div @click.prevent="closeDialog()" v-if="dialog.show" class="dialog-mask">
      <div class="dialog-image" :style="dialogStyle">
        <img :style="{ transform: transform }" class="img" :src="dialog.img" />

        <div @click.stop="closeDialog()" class="close">关闭</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as THREE from "three";
import offset from "offset";

import { RoomEnvironment } from "three/addons/environments/RoomEnvironment.js";
import CameraControls from "camera-controls";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { OrbitControls } from "three/addons/controls/OrbitControls.js";

import { KTX2Loader } from "three/addons/loaders/KTX2Loader.js";
import { MeshoptDecoder } from "three/addons/libs/meshopt_decoder.module.js";

CameraControls.install({ THREE: THREE });

let camera, scene, renderer, controls, clock;
// 容器
let container = document.body;

export default {
  name: "HomeView",
  data() {
    return {
      // 事件
      events: {},

      // 相机和视点的距离
      EPS: 1e-5,

      // 移动高度
      movieHight: 2.2,
      // 相机配置
      cameraOption: {
        position: { x: 0, y: 2, z: -26 },
        lookAt: { x: 0, y: 2, z: 28 },
      },

      dialog: {
        show: false,
        img: "img/photo/left_1.png",
      },
      dialogStyle: {
        width: "300px",
        height: "80vh",
      },
      transform: "rotate(180deg)",
    };
  },
  mounted() {
    this.init();
  },

  methods: {
    /**
     * 
    a. 创建一个场景实例 scene，是放置物体的空间
    b. 创建一个摄像机 camera，通过设置位置等去观察场景中的物体
    c. 创建一个渲染器 render，将渲染器的节点添加到容器中, 这一步很重要
    d. 创建控制器 controls。
    e. 配置灯光。
    */
    init() {
      const that = this;
      // 默认尺寸
      const width = window.innerWidth;
      const height = window.innerHeight;
      const eps = this.EPS;

      //获取dom节点
      const dom = document.getElementById("webgl");

      //场景渲染器创建
      renderer = new THREE.WebGLRenderer({
        // canvas: document.getElementById('can3d'), //渲染器绘制其输出的画布，
        // alpha: false, // 画布是否包含alpha（透明度）缓冲区。默认值为false。
        // premultipliedAlpha: true, //渲染器是否会假设颜色具有 预乘alpha。默认为true。
        antialias: true, //是否执行抗锯齿。默认值为false。
        // preserveDrawingBuffer: true, //是否保留缓冲区直到手动清除或覆盖。默认值为false。
        // depth: true, //绘图缓冲区是否具有至少16位的 深度缓冲区。默认为true。
        // autoClear: true, //定义渲染器是否应在渲染帧之前自动清除其输出。

        //以下为高级进阶调渲染后期
        // gammaFactor: 0.5, //伽马基础值
        // gammaInput: true, //如果设置，那么它期望所有纹理和颜色都是预乘伽马。默认值为false。
        // gammaOutput: true, //如果设置，那么它期望所有纹理和颜色需要以预乘伽马输出。默认值为false。
        // shadowMap: null, //如果使用，它包含阴影贴图的引用。
        // physicalCorrectLights: true, //是否使用物理上正确的照明模式。默认值为false。
        toneMapping: 0.2, //曝光值
        // toneMappingExposure: 3, //色调映射的曝光级别。默认值为1。
        // renderLists: [], //在内部用于处理场景对象渲染的排序
        // sortObjects: true, //定义渲染器是否应对对象进行排序。默认为true。
        logarithmicDepthBuffer: true,
      });
      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.setSize(width, height);
      renderer.outputEncoding = THREE.sRGBEncoding;
      // renderer.outputEncoding = THREE.LinearEncoding; //更改场景的色彩模式
      // renderer.toneMapping = THREE.ReinhardToneMapping //曝光值
      dom.appendChild(renderer.domElement);

      //透视投影相机
      camera = new THREE.PerspectiveCamera(45, width / height, 0.1, 10000);

      //三维场景Scene
      scene = new THREE.Scene();
      // scene.background = new THREE.Color(0xbbbbbb);

      const environment = new RoomEnvironment();
      const pmremGenerator = new THREE.PMREMGenerator(renderer);
      const hdr = new THREE.CubeTextureLoader().load([
        "hdr/px.png",
        "hdr/nx.png",
        "hdr/py.png",
        "hdr/ny.png",
        "hdr/pz.png",
        "hdr/nz.png",
      ]);
      scene.environment = hdr;
      scene.background = hdr;
      // scene.environment = pmremGenerator.fromScene(environment).texture;
      // environment.dispose();

      // //环境光:没有特定方向，整体改变场景的光照明暗
      const ambient = new THREE.AmbientLight(0xffffff, 0.2);
      scene.add(ambient);

      // 时钟
      clock = new THREE.Clock();

      //添加模型
      const ktx2Loader = new KTX2Loader().detectSupport(renderer);
      var loader = new GLTFLoader().setPath("img/");
      loader.setKTX2Loader(ktx2Loader);
      loader.setMeshoptDecoder(MeshoptDecoder);
      loader.load("走廊4.glb", function (gltf) {
        gltf.scene.traverse(function (child) {
          if (child.isMesh) {
            // child.material.emissive = child.material.color;
            // child.material.emissiveMap = child.material.map;
          }

          //设置 图片 到 画框
          // that.setChildMaterial(child);
          const childName = child.name;
          const img = that.getChildMaterialImg(childName);
          if (img) {
            const textureLoad = new THREE.TextureLoader();
            const imgMater = textureLoad.load(img);
            child.material = new THREE.MeshBasicMaterial({
              map: imgMater,
              emissiveMap: imgMater,
            });
            child.material.map.flipY = false;
            if (childName.search("r") != -1) {
              child.material.map.flipY = true;
            }
          }
        });

        //模型的大小
        gltf.scene.scale.set(1, 1, 1); // scale here

        //模型的位置
        gltf.scene.position.x = 0;
        gltf.scene.position.y = 0;
        gltf.scene.position.z = 0;

        //场景加入 模型
        scene.add(gltf.scene);
      });

      //这里采用了 github的 CameraControls
      controls = new CameraControls(camera, renderer.domElement);
      controls.maxDistance = eps;
      controls.minZoom = 0.5;
      controls.maxZoom = 2;
      controls.dragToOffset = false;
      controls.distance = 1.5; //相机与视角距离
      controls.dampingFactor = 0.01; // 阻尼运动
      controls.truckSpeed = 0.01; // 拖动速度
      controls.AmbientLight = 1; //自动补充环境光 已关闭
      controls.mouseButtons.wheel = CameraControls.ACTION.ZOOM;
      controls.mouseButtons.right = CameraControls.ACTION.NONE;
      controls.touches.two = CameraControls.ACTION.TOUCH_ZOOM;
      controls.touches.three = CameraControls.ACTION.NONE;

      //绑定事件
      this.bindEvent();
      //动画
      this.animate();
      //初始化 相机视角
      this.lookat();

      //监听大小变化
      window.addEventListener("resize", this.resize);
    },

    //根据子模型的名称 获取 子模型的 对应图片的材质
    getChildMaterialImg(childName) {
      var img = "";
      switch (childName) {
        case "l01":
          img = "img/photo/left_1.png";
          break;

        case "l02":
          img = "img/photo/left_2.png";
          break;

        case "l03":
          img = "img/photo/left_3.png";
          break;

        case "l04":
          img = "img/photo/left_4.png";
          break;

        case "l05":
          img = "img/photo/left_5.png";
          break;

        case "l06":
          img = "img/photo/left_6.png";
          break;

        case "l07":
          img = "img/photo/left_7.png";
          break;

        case "l08":
          img = "img/photo/left_8.png";
          break;

        case "l09":
          img = "img/photo/left_9.png";
          break;

        case "l10":
          img = "img/photo/left_10.png";
          break;

        case "l11":
          img = "img/photo/left_11.png";
          break;

        case "l12":
          img = "img/photo/left_12.png";
          break;

        //右边

        case "r01":
          img = "img/photo/right_1.png";
          break;

        case "r02":
          img = "img/photo/right_2.png";
          break;

        case "r03":
          img = "img/photo/right_3.png";
          break;

        case "r04":
          img = "img/photo/right_4.png";
          break;

        case "r05":
          img = "img/photo/right_5.png";
          break;

        case "r06":
          img = "img/photo/right_6.png";
          break;

        case "r07":
          img = "img/photo/right_7.png";
          break;

        case "r08":
          img = "img/photo/right_8.png";
          break;

        case "r09":
          img = "img/photo/right_9.png";
          break;

        case "r10":
          img = "img/photo/right_10.png";
          break;

        case "r11":
          img = "img/photo/right_11.png";
          break;

        case "r12":
          img = "img/photo/right_12.png";
          break;

        case "r13":
          img = "img/photo/right_13.png";
          break;

        case "r14":
          img = "img/photo/right_14.png";
          break;

        case "r15":
          img = "img/photo/right_15.png";
          break;

        default:
          // default的代码块
          img = null;
      }

      return img;
    },

    /**
     * 事件绑定
     */
    bindEvent() {
      const dom = document.body;
      dom.addEventListener("mousedown", this.mouseDown);
      dom.addEventListener("mouseup", this.mouseUp);
    },

    //加载动画  由官方提供
    animate() {
      const delta = clock.getDelta();
      requestAnimationFrame(this.animate);
      controls.update(delta);
      renderer.render(scene, camera);
    },

    /**
     * 重新设置大小
     */
    resize() {
      // 默认尺寸
      const size = {};
      size.width = container.clientWidth;
      size.height = container.clientHeight;
      renderer.setSize(size.width, size.height);
      // 更新相机的宽高比
      camera.aspect = size.width / size.height;
      camera.updateProjectionMatrix();
    },

    /**
     * 初始化视角
     * @returns
     */
    async lookat() {
      const eps = this.EPS;
      const cameraOption = this.cameraOption;
      if (!cameraOption) {
        return;
      }
      const { position, lookAt } = cameraOption;
      const lookatV3 = new THREE.Vector3(position.x, position.y, position.z);
      lookatV3.lerp(new THREE.Vector3(lookAt.x, lookAt.y, lookAt.z), eps);
      controls.zoomTo(0);
      await controls.setLookAt(
        position.x,
        position.y,
        position.z,
        lookatV3.x,
        lookatV3.y,
        lookatV3.z,
        false
      );
    },

    // 鼠标点击下去
    mouseDown(event) {
      this.events.startXY = { x: event.clientX, y: event.clientY };
    },

    //鼠标释放 起来
    mouseUp(event) {
      const that = this;
      //查看的高度
      const movieHight = this.movieHight;
      // x, y 偏移
      const { top, left } = offset(container);
      const { x, y } = this.events.startXY;
      const offsetPoor = 2;

      // 判断是否点击事件，如果偏移量小于2就是点击事件
      if (
        Math.abs(event.clientX - x) > offsetPoor ||
        Math.abs(event.clientY - y) > offsetPoor
      ) {
        return;
      }

      const rayRes = this.getBoxRaycaster({
        x: event.clientX - left,
        y: event.clientY - top,
      });

      if (rayRes) {
        const { position, lookat, mesh } = rayRes;

        const { name } = mesh;
        console.log("点击了：", name);

        that.clickMesh(name);

        if (name == "地面") {
          // 点击地面移动
          this.moveTo(
            { x: position.x, y: movieHight, z: position.z },
            { x: lookat.x, y: movieHight, z: lookat.z }
          );
        }
      }
    },

    /**
     * 传入坐标，返回当前的raycaster屏幕坐标
     * x, y 是画布相对坐标
     */
    getBoxRaycaster({ x, y }) {
      const eps = this.EPS;
      // 射线计算
      const mouse = new THREE.Vector2();
      mouse.x = (x / container.clientWidth) * 2 - 1;
      mouse.y = -(y / container.clientHeight) * 2 + 1;
      // 射线计算
      const raycaster = new THREE.Raycaster();
      raycaster.setFromCamera(mouse, camera);
      const intersects = raycaster.intersectObjects(scene.children);
      const intersect = intersects[0];
      if (intersect) {
        const position = intersect.point;
        const lookat = camera.position.lerp(position, 1 + eps);
        // 点击元素
        const mesh = intersect.object;
        return { position: position, lookat, mesh };
      } else {
        console.log("点击空气？");
      }
      return false;
    },

    /**
     * 移动动画
     * @param {*} to
     * @param {*} lookat
     * @param {*} duration
     */
    moveTo(position, lookat) {
      const eps = this.EPS;
      controls.saveState();
      const lookatV3 = new THREE.Vector3(position.x, position.y, position.z);
      lookatV3.lerp(new THREE.Vector3(lookat.x, lookat.y, lookat.z), eps);

      // 获取当前的lookAt参数
      const fromPosition = new THREE.Vector3();
      const fromLookAt = new THREE.Vector3();
      controls.getPosition(fromPosition);
      controls.getTarget(fromLookAt);

      const lookatV32 = new THREE.Vector3(position.x, position.y, position.z);
      lookatV32.lerp(new THREE.Vector3(lookat.x, lookat.y, lookat.z), eps);
      controls.setLookAt(
        position.x,
        position.y,
        position.z,
        lookatV3.x,
        lookatV3.y,
        lookatV3.z,
        true
      );
    },

    //点击 模型的子模型
    clickMesh(name) {
      var show = false;
      var img = "img/photo/left_1.png";
      var width = "300px";
      var height = "80vh";
      var transform = "rotate(180deg)";
      img = this.getChildMaterialImg(name);
      if (img) {
        show = true;
      }
      const dialog = {
        show: show,
        img: img,
      };

      const style = {
        width: width,
        height: height,
      };
      if (name.search("r") == -1) {
        transform = "rotate(0deg)";
      }
      this.dialog = dialog;
      this.dialogStyle = style;
      this.transform = transform;
    },
    closeDialog() {
      this.dialog.show = false;
    },
  },
};
</script>

<style lang="scss">
.dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 111;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);

  display: flex;

  /* 居中对齐 */
  justify-content: center;
  /* 交叉轴居中 */
  align-items: center;
}
.dialog-image {
  width: 300px;
  height: 80vh;
  background-color: #ffffff;

  position: relative;
  .close {
    position: absolute;
    right: 0px;
    top: -25px;
    background: #ffffff;
    color: #000;
    border: 1px solid #000;
    padding: 5px 8px;
  }
  .img {
    width: 100%;
    height: 100%;
  }
}
</style>
